import { createAction, props } from "@ngrx/store";
import {User, UserIrenYouRequest} from "@modules/users/users.interface";
import {ServicesResponse} from "@core/model/servicesResponse";

export const UserLoadAction = createAction(
  '[Users] User Load'
);

export const UserLoadedAction = createAction(
  '[Users] User Loaded',
  props<{ users: User[] }>()
);

export const UserErrorLoadingAction = createAction(
  '[Users] Error Loading Users'
);

export const UserAddAction = createAction(
  '[Users] users add',
  props<{ user: Partial<User> }>()
);

export const UserAddedAction = createAction(
  '[Users] User added',
  props<{ user: User }>()
);

export const UserErrorAddingAction = createAction(
  '[Users] Error Adding User'
);

export const UserDeleteAction = createAction(
  '[Users] Delete User',
  props<{ user: User }>()
);

export const UserDeletedAction = createAction(
  '[Users] User deleted',
  props<{ user: User }>()
);

export const UserDeletingErrorAction = createAction(
  '[Users] Error Deleting User'
);

export const UserUpdateAction = createAction(
  '[User] Update user',
  props<{ user: Partial<User> }>()
);

export const UserUpdatedAction = createAction(
  '[Users] User updated',
  props<{ user: Partial<User> }>()
);

export const UserPasswordUpdateAction = createAction(
  '[Users] Update password User Dashboard',
  props<{ user: Partial<User> }>()
);

export const UserPasswordIrenYouUpdateAction = createAction(
  '[Users] Update password IrenYou',
  props<{ user: Partial<UserIrenYouRequest> }>()
);

export const UserPasswordUpdatedAction = createAction(
  '[Users] Password updated'
);

export const UserErrorUpdatingAction = createAction(
  '[Users] Error Updating User'
);

export const UserErrorUpdatingPasswordAction = createAction(
  '[Users] Error Updating Password'
);

export const UserNotifyPasswordChangeAction = createAction(
  '[Users] Send change password notification',
  props<{ user: Partial<User> }>()
);

export const UserNotifiedPasswordChangeAction = createAction(
  '[Users] Notification sent',
  props<{ status: ServicesResponse}>()
);

export const UserErrorSendindNotificationAction = createAction(
  '[Users] Error Sending Notification'
);

export const AuthLoginAction = createAction(
  '[Login Page] User login',
  props<{ user: User }>()
);

export const AuthLogoutAction = createAction(
  '[Top Menu] User logout'
);
